import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const env = import.meta.env.VITE_ENV;

const CANONICAL_HOST = "suppli.no";

// Anything allowed to remain on suppli.cloud:
const CLOUD_ALLOWED: RegExp[] = [
    /^\/dashboard(?:\/|$)/,
    /^\/login(?:\/|$)/,
    /^\/registration(?:\/|$)/,
    /^\/verify-email(?:\/|$)/,
    /^\/forgot-password(?:\/|$)/,
    /^\/reset-password(?:\/|$)/,
    /^\/email-verify(?:\/|$)/,
    /^\/invite(?:\/|$)/,
    /^\/select-company(?:\/|$)/,
];

const isAllowedOnCloud = (path: string) => CLOUD_ALLOWED.some(rx => rx.test(path));

const DomainGuard: React.FC = () => {
    const location = useLocation();

    useEffect(() => {

        const { hostname, search, hash } = window.location;
        const path = location.pathname;

        if (env == "local" || env == "dev") {
            if(path === "/") {
                window.location.replace(`/login`);
            }

            return;
        }

        // If we're on suppli.cloud and the path is NOT whitelisted, send to suppli.no/{same path}
        if (!isAllowedOnCloud(path)) {
            window.location.replace(`https://${CANONICAL_HOST}${path}${search}${hash}`);
            return;
        }
    }, [location]);

    return null;
};

export default DomainGuard;
